import { FOCUSABLE_SELECTOR } from './focusableSelector';

export function forwardCellFocus(cell: HTMLElement) {
  const focusable = Array.from(
    cell.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR),
  ).find(
    (element) =>
      element.offsetParent !== null &&
      !element.matches(
        'input[type="checkbox"], input[type="radio"], .bitts-tooltip-trigger',
      ),
  );
  focusable?.focus();
}
